import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { DoctorListSer } from './Services/DoctorListSer';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import axios from 'axios';
const ViewDoctors= () => {
    useEffect(() => {
             const scriptUrls = [
               'assets/js/jquery.min.js',
               'assets/js/bootstrap.bundle.min.js',
               'assets/js/moment.min.js',
               'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
               'assets/vendor/overlay-scroll/custom-scrollbar.js',
               'assets/vendor/daterange/daterange.js',
               'assets/vendor/daterange/custom-daterange.js',
               'assets/vendor/datatables/dataTables.min.js',
               'assets/vendor/datatables/dataTables.bootstrap.min.js',
               'assets/vendor/datatables/custom/custom-datatables.js',
               'assets/js/custom.js'
             ];
         
             let isCancelled = false;
         
             // Load scripts sequentially
             const loadScriptsSequentially = async () => {
               for (const url of scriptUrls) {
                 if (isCancelled) break;
         
                 await new Promise((resolve, reject) => {
                   const script = document.createElement('script');
                   script.src = url;
                   script.onload = resolve;
                   script.onerror = reject;
                   document.body.appendChild(script);
                 });
               }
             };
         
             loadScriptsSequentially();
         
             return () => {
               isCancelled = true;
               // Optionally remove scripts if needed
             };
           }, []);
    const navigator = useNavigate();
    const handleUpdateClick = (e,id) => {
        e.preventDefault();
         // Navigate to /page2 and pass the value
         navigator('/update-doctors', { state: { uata: id } });
         window.location.reload();
       };
       const handleViewClick = (e,id) => {
        e.preventDefault();
         // Navigate to /page2 and pass the value
         navigator('/doctor-profile', { state: { uata: id } });
         window.location.reload();
       };
       
    const handleDeleteClick = (e,id) => {
       e.preventDefault();
        // Deletes the department
        const REST_API_BASE_URL = `http://localhost:8080/api/delete-department/${id}`;
              
              axios.post(REST_API_BASE_URL)
                .then((response) => {
                  console.log(response.data);
                  window.alert(`This happend with: ${response.data}`);
                  
                  // After deletion, redirect to another page (e.g., home or item list)
                  navigator("/view-doctors"); // Navigates back to the homepage or another route
                })
                .catch((error) => {
                  window.alert("Error occurred while deleting the item.");
                  console.error(error);
                });
      };
      const handleDeleteAll =(e) =>{
        e.preventDefault();
        // Show confirmation dialog
            const confirmDelete = window.confirm(
              `Are you sure you want to delete all items?`
            );
        
            if (confirmDelete) {
              // If confirmed, perform the delete action
              const REST_API_BASE_URL = `http://localhost:8080/api/deleteAllBooks`;
              
              axios
                .post(REST_API_BASE_URL)
                .then((response) => {
                  console.log(response.data);
                  window.alert(`This happend with: ${response.data}`);
                  
                  // After deletion, redirect to another page (e.g., home or item list)
                  navigator("/view-doctors"); // Navigates back to the homepage or another route
                })
                .catch((error) => {
                  window.alert("Error occurred while deleting the item.");
                  console.error(error);
                });
            } else {
              // If cancelled, do nothing (or show a cancellation message)
              window.alert("Deletion cancelled");
              navigator("/view-doctors");
            }
      }
    /* const dummyData =[
        {
            "id":1,
            "users":"Gautam Kumar",
            "title":"Dam it",
            "author":"Rest Api",
            "isbn":"isbn34546",
            "description":"This is really good",
            "backCover":"file1.jpg"
        }
    ] */
        const [department, setDepartment] = useState([]);
        const srcImg="http://localhost:8080/Images/";
        useEffect(() =>{
            const REST_API_BASE_URL = `http://localhost:8080/api/listBooksByUsers`;
            const listDoctorUser =() => axios.get(REST_API_BASE_URL);
            listDoctorUser().then((response) => {
                setDepartment(response.data);
            }).catch(error =>{
                console.error(error);
            })
        } , [])
        
        return(
            <div>
  {/* App hero header starts */}
  <div className="app-hero-header d-flex align-items-center">
    {/* Breadcrumb starts */}
    <ol className="breadcrumb">
      <li className="breadcrumb-item">
        <a href="index-2.html">
          <i className="ri-home-3-line" />
        </a>
      </li>
      <li className="breadcrumb-item">Doctors </li>
      <li className="breadcrumb-item text-primary" aria-current="page">
        Doctors List
      </li>
    </ol>
    {/* Breadcrumb ends */}
    {/* Sales stats starts */}
    <div className="ms-auto d-lg-flex d-none flex-row">
      <div className="input-group">
        <span className="input-group-text bg-primary-lighten">
          <i className="ri-calendar-2-line text-primary" />
        </span>
        <input type="text" id="abc" className="form-control custom-daterange" />
      </div>
    </div>
    {/* Sales stats ends */}
  </div>
  {/* App Hero header ends */}
  {/* App body starts */}
  <div className="app-body">
    {/* Row starts */}
    <div className="row gx-4">
      <div className="col-sm-12">
        <div className="card">
          <div className="card-header d-flex align-items-center justify-content-between">
            <h5 className="card-title">Doctors List</h5>
            <a href="/add-doctors" className="btn btn-primary ms-auto">Add Doctors List</a>
          </div>
          <div className="card-body">
            {/* Table starts */}
            <div className="table-responsive">
              <table id="scrollVertical" className="table m-0 align-middle">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Designation</th>
                    <th>Mobile</th>
                    <th>Email</th>
                    <th>DOJ</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>001</td>
                    <td>
                      <img src="assets/images/doctor.png" className="img-2x rounded-5 me-1" alt="Doctors Admin Template" />
                      Willian Mathews
                    </td>
                    <td>Nurologist</td>
                    <td>
                      0987654321
                    </td>
                    <td>test@testing.com</td>
                    <td>20/10/2020</td>
                    <td>
                      <div className="d-inline-flex gap-1">
                        <button className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow" >
                          <i className="ri-delete-bin-line" />
                        </button>
                        <a href="/update-doctors" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Edit Doctor Member"
                         onClick={(e)=>handleUpdateClick(e,1)}>
                          <i className="ri-edit-box-line" />
                        </a>
                        <a href="/doctor-profile" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="View Doctor Member"
                         onClick={(e)=>handleViewClick(e,1)}>
                          <i className="ri-eye-line" />
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>002</td>
                    <td>
                      <img src="assets/images/doctor1.png" className="img-2x rounded-5 me-1" alt="Doctors Admin Template" />
                      Adam Bradley
                    </td>
                    <td>Nurologist</td>
                    <td>
                      0987654321
                    </td>
                    <td>test@testing.com</td>
                    <td>12/03/2018</td>
                    <td>
                    <div className="d-inline-flex gap-1">
                        <button className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow" >
                          <i className="ri-delete-bin-line" />
                        </button>
                        <a href="/update-doctors" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Edit Doctor Member"
                         onClick={(e)=>handleUpdateClick(e,2)}>
                          <i className="ri-edit-box-line" />
                        </a>
                        <a href="/doctor-profile" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="View Doctor Member"
                         onClick={(e)=>handleViewClick(e,2)}>
                          <i className="ri-eye-line" />
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>003</td>
                    <td>
                      <img src="assets/images/doctor2.png" className="img-2x rounded-5 me-1" alt="Doctors Admin Template" />
                      Mayra Hatfield
                    </td>
                    <td>Nurologist</td>
                    <td>
                      0987654321
                    </td>
                    <td>test@testing.com</td>
                    <td>03/09/2022</td>
                    <td>
                    <div className="d-inline-flex gap-1">
                        <button className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow" >
                          <i className="ri-delete-bin-line" />
                        </button>
                        <a href="/update-doctors" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Edit Doctor Member"
                         onClick={(e)=>handleUpdateClick(e,3)}>
                          <i className="ri-edit-box-line" />
                        </a>
                        <a href="/doctor-profile" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="View Doctor Member"
                         onClick={(e)=>handleViewClick(e,3)}>
                          <i className="ri-eye-line" />
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>004</td>
                    <td>
                      <img src="assets/images/doctor3.png" className="img-2x rounded-5 me-1" alt="Doctors Admin Template" />
                      Nicole Sellers
                    </td>
                    <td>Nurologist</td>
                    <td>
                      0987654321
                    </td>
                    <td>test@testing.com</td>
                    <td>18/12/2013</td>
                    <td>
                    <div className="d-inline-flex gap-1">
                        <button className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow" >
                          <i className="ri-delete-bin-line" />
                        </button>
                        <a href="/update-doctors" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Edit Doctor Member"
                         onClick={(e)=>handleUpdateClick(e,4)}>
                          <i className="ri-edit-box-line" />
                        </a>
                        <a href="/doctor-profile" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="View Doctor Member"
                         onClick={(e)=>handleViewClick(e,4)}>
                          <i className="ri-eye-line" />
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>005</td>
                    <td>
                      <img src="assets/images/doctor4.png" className="img-2x rounded-5 me-1" alt="Doctors Admin Template" />
                      Roseann Kane
                    </td>
                    <td>Nurologist</td>
                    <td>
                      0987654321
                    </td>
                    <td>test@testing.com</td>
                    <td>23/10/2016</td>
                    <td>
                    <div className="d-inline-flex gap-1">
                        <button className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow" >
                          <i className="ri-delete-bin-line" />
                        </button>
                        <a href="/update-doctors" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Edit Doctor Member"
                         onClick={(e)=>handleUpdateClick(e,5)}>
                          <i className="ri-edit-box-line" />
                        </a>
                        <a href="/doctor-profile" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="View Doctor Member"
                         onClick={(e)=>handleViewClick(e,5)}>
                          <i className="ri-eye-line" />
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>006</td>
                    <td>
                      <img src="assets/images/doctor5.png" className="img-2x rounded-5 me-1" alt="Doctors Admin Template" />
                      Roger Briggs
                    </td>
                    <td>Nurologist</td>
                    <td>
                      0987654321
                    </td>
                    <td>test@testing.com</td>
                    <td>17/02/2019</td>
                    <td>
                    <div className="d-inline-flex gap-1">
                        <button className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow" >
                          <i className="ri-delete-bin-line" />
                        </button>
                        <a href="/update-doctors" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Edit Doctor Member"
                         onClick={(e)=>handleUpdateClick(e,6)}>
                          <i className="ri-edit-box-line" />
                        </a>
                        <a href="/doctor-profile" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="View Doctor Member"
                         onClick={(e)=>handleViewClick(e,6)}>
                          <i className="ri-eye-line" />
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>007</td>
                    <td>
                      <img src="assets/images/doctor.png" className="img-2x rounded-5 me-1" alt="Doctors Admin Template" />
                      Mervin Elliott
                    </td>
                    <td>Nurologist</td>
                    <td>
                      0987654321
                    </td>
                    <td>test@testing.com</td>
                    <td>15/06/2023</td>
                    <td>
                    <div className="d-inline-flex gap-1">
                        <button className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow" >
                          <i className="ri-delete-bin-line" />
                        </button>
                        <a href="/update-doctors" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Edit Doctor Member"
                         onClick={(e)=>handleUpdateClick(e,7)}>
                          <i className="ri-edit-box-line" />
                        </a>
                        <a href="/doctor-profile" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="View Doctor Member"
                         onClick={(e)=>handleViewClick(e,7)}>
                          <i className="ri-eye-line" />
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>008</td>
                    <td>
                      <img src="assets/images/doctor3.png" className="img-2x rounded-5 me-1" alt="Doctors Admin Template" />
                      Fermin George
                    </td>
                    <td>Nurologist</td>
                    <td>
                      0987654321
                    </td>
                    <td>test@testing.com</td>
                    <td>29/08/2017</td>
                    <td>
                    <div className="d-inline-flex gap-1">
                        <button className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow" >
                          <i className="ri-delete-bin-line" />
                        </button>
                        <a href="/update-doctors" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Edit Doctor Member"
                         onClick={(e)=>handleUpdateClick(e,8)}>
                          <i className="ri-edit-box-line" />
                        </a>
                        <a href="/doctor-profile" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="View Doctor Member"
                         onClick={(e)=>handleViewClick(e,8)}>
                          <i className="ri-eye-line" />
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>009</td>
                    <td>
                      <img src="assets/images/doctor4.png" className="img-2x rounded-5 me-1" alt="Doctors Admin Template" />
                      Olen Frye
                    </td>
                    <td>Nurologist</td>
                    <td>
                      0987654321
                    </td>
                    <td>test@testing.com</td>
                    <td>02/09/2014</td>
                    <td>
                    <div className="d-inline-flex gap-1">
                        <button className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow" >
                          <i className="ri-delete-bin-line" />
                        </button>
                        <a href="/update-doctors" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Edit Doctor Member"
                         onClick={(e)=>handleUpdateClick(e,9)}>
                          <i className="ri-edit-box-line" />
                        </a>
                        <a href="/doctor-profile" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="View Doctor Member"
                         onClick={(e)=>handleViewClick(e,9)}>
                          <i className="ri-eye-line" />
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>010</td>
                    <td>
                      <img src="assets/images/doctor2.png" className="img-2x rounded-5 me-1" alt="Doctors Admin Template" />
                      Roger Briggs
                    </td>
                    <td>Nurologist</td>
                    <td>
                      0987654321
                    </td>
                    <td>test@testing.com</td>
                    <td>17/02/2019</td>
                    <td>
                    <div className="d-inline-flex gap-1">
                        <button className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow" >
                          <i className="ri-delete-bin-line" />
                        </button>
                        <a href="/update-doctors" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Edit Doctor Member"
                         onClick={(e)=>handleUpdateClick(e,10)}>
                          <i className="ri-edit-box-line" />
                        </a>
                        <a href="/doctor-profile" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="View Doctor Member"
                         onClick={(e)=>handleViewClick(e,10)}>
                          <i className="ri-eye-line" />
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>011</td>
                    <td>
                      <img src="assets/images/doctor.png" className="img-2x rounded-5 me-1" alt="Doctors Admin Template" />
                      Mervin Elliott
                    </td>
                    <td>Nurologist</td>
                    <td>
                      0987654321
                    </td>
                    <td>test@testing.com</td>
                    <td>15/06/2023</td>
                    <td>
                    <div className="d-inline-flex gap-1">
                        <button className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow" >
                          <i className="ri-delete-bin-line" />
                        </button>
                        <a href="/update-doctors" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Edit Doctor Member"
                         onClick={(e)=>handleUpdateClick(e,11)}>
                          <i className="ri-edit-box-line" />
                        </a>
                        <a href="/doctor-profile" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="View Doctor Member"
                         onClick={(e)=>handleViewClick(e,11)}>
                          <i className="ri-eye-line" />
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>012</td>
                    <td>
                      <img src="assets/images/doctor3.png" className="img-2x rounded-5 me-1" alt="Doctors Admin Template" />
                      Fermin George
                    </td>
                    <td>Nurologist</td>
                    <td>
                      0987654321
                    </td>
                    <td>test@testing.com</td>
                    <td>29/08/2017</td>
                    <td>
                    <div className="d-inline-flex gap-1">
                        <button className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow" >
                          <i className="ri-delete-bin-line" />
                        </button>
                        <a href="/update-doctors" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Edit Doctor Member"
                         onClick={(e)=>handleUpdateClick(e,12)}>
                          <i className="ri-edit-box-line" />
                        </a>
                        <a href="/doctor-profile" className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="View Doctor Member"
                         onClick={(e)=>handleViewClick(e,12)}>
                          <i className="ri-eye-line" />
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/* Table ends */}
            {/* Modal Delete Row */}
            <div className="modal fade" id="delRow" tabIndex={-1} aria-labelledby="delRowLabel" aria-hidden="true">
              <div className="modal-dialog modal-sm">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="delRowLabel">
                      Confirm
                    </h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                  </div>
                  <div className="modal-body">
                    Are you sure you want to delete the staff member?
                  </div>
                  <div className="modal-footer">
                    <div className="d-flex justify-content-end gap-2">
                      <button className="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">No</button>
                      <button className="btn btn-danger" data-bs-dismiss="modal" aria-label="Close" onClick={handleDeleteClick}>Yes</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* Row ends */}
  </div>
  {/* App body ends */}
</div>
        );
        
}

export default ViewDoctors;




